export default "__VITE_ASSET__MG4OCviB__"